import { container, lazyInject } from '@intelingu/core/IoC/container';
import { CardStore } from '@intelingu/core/stores/CardStore';
import { inject, observer } from 'mobx-react';
import * as React from 'react';
import { Component } from 'react';
import { UserStore } from '@intelingu/core/stores/UserStore';
import { CardComponent } from './card/CardComponent';
import Joyride from "react-joyride";
import {AppStore} from "../../stores/AppStore";
import {BootstrapStore} from "../../stores/BootstrapStore";
import {Redirect} from "react-router";

export interface CourseLayoutProps {
}

@observer export class CourseLayout extends Component<CourseLayoutProps, any> {

    @lazyInject(UserStore) userStore: UserStore;
    @lazyInject(CardStore) cardStore: CardStore;
    @lazyInject(AppStore) appStore: AppStore;
    @lazyInject(BootstrapStore) bootstrapStore: BootstrapStore;

    componentDidMount(): void {
        if (this.bootstrapStore.skipFirstLoad) {
            this.bootstrapStore.skipFirstLoad = false;
        }
    }

    // reset card store
    componentWillUnmount(): void {
        this.cardStore.reset();
    }

    render() {
        if (!this.userStore.isReady) {
            return null;
        }

        if (!this.userStore.user.email_confirmed) {
            return <Redirect to={'/'} />
        }

        return <div className={'course-layout'}>
            <CardComponent />

            { (!this.appStore.tourFinished && this.appStore.tour.length > 0) && (
                <Joyride
                    steps={this.appStore.tour}
                    run={this.appStore.isJoyrideRunning}
                    stepIndex={this.appStore.tourIndex}
                    showSkipButton={false}
                    hideBackButton={true}
                    disableCloseOnEsc={true}
                    disableOverlayClose={true}
                    styles={{
                        buttonClose: {
                            display: 'none',
                        },
                        buttonNext: {
                            backgroundColor: 'rgb(231, 69, 67)'
                        },
                    }}
                    locale={{
                        back: 'Zurück',
                        next: 'Weiter',
                        last: 'Fertig'
                    }}
                    disableScrolling={this.appStore.tourDisableScrolling}
                    callback={this.appStore.handleJoyrideCallback}
                    continuous={true}
                />
            )}
        </div>
    }

}
